/**
 * Lake house LP API
 *
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { AssetDto } from './assetDto';

/**
 * Asset DTO
 */
export interface BalanceDto {
  accountId?: number;
  assetId?: number;
  asset?: AssetDto;
  total?: number;
  credit?: number;
  free?: number;
}
